import { Controller } from "@hotwired/stimulus"

const GTAG_SCRIPT_ID = "ga4-gtag-script"
const GTAG_ENDPOINT = "https://www.googletagmanager.com/gtag/js?id="
const DISABLE_FLAG_PREFIX = "ga-disable-"

export default class extends Controller {
  static values = {
    enabled: { type: Boolean, default: false },
    measurementId: String,
  }

  connect() {
    if (!this.hasMeasurementIdValue || this.measurementIdValue.trim() === "") return

    if (this.enabledValue) {
      this.enableTracking()
    } else {
      this.disableTracking()
    }
  }

  enableTracking() {
    window[`${DISABLE_FLAG_PREFIX}${this.measurementIdValue}`] = false
    this.bootstrapGtag()
    this.configureMeasurementId()
  }

  disableTracking() {
    window[`${DISABLE_FLAG_PREFIX}${this.measurementIdValue}`] = true
  }

  bootstrapGtag() {
    if (!document.getElementById(GTAG_SCRIPT_ID)) {
      const script = document.createElement("script")
      script.id = GTAG_SCRIPT_ID
      script.async = true
      script.src = `${GTAG_ENDPOINT}${encodeURIComponent(this.measurementIdValue)}`
      document.head.appendChild(script)
    }

    window.dataLayer = window.dataLayer || []
    window.gtag = window.gtag || function gtag() {
      window.dataLayer.push(arguments)
    }

    if (window.__viddleGtagInitialized) return

    window.gtag("js", new Date())
    window.__viddleGtagInitialized = true
  }

  configureMeasurementId() {
    const configuredIds = window.__viddleGtagConfiguredIds || {}
    if (configuredIds[this.measurementIdValue]) return

    window.gtag("config", this.measurementIdValue, {
      anonymize_ip: true,
      allow_google_signals: false,
    })

    configuredIds[this.measurementIdValue] = true
    window.__viddleGtagConfiguredIds = configuredIds
  }
}
